module.exports = __webpack_public_path__ + "static/media/cart-old-mobile.edb1cdb2.png";